import { Paper } from "@mui/material";

import DefaultIcon from "./DefaultIcon";

const DefaultIconWithPaper = () => (
  <Paper
    sx={{
      width: "72px",
      maxWidth: "72px",
      height: "72px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 0 0.25rem 0",
    }}
  >
    <DefaultIcon />
  </Paper>
);

export default DefaultIconWithPaper;
